import {Card, CardMedia, Typography} from "@mui/material"

export function HelpNote({instruction, index}) {
	return (
		<div
			id={`instruction-${index}-div-wrapper`}
			style={{
				alignItems: "center",
				width: "100%",
				marginRight: "10px"
			}}
		>
			<Card
				variant={"note"}
				sx={{
					display: "flex",
					alignItems: "stretch",
					width: "100%",
					backgroundColor: "white",
					borderLeftWidth: "5px",
					borderRightWidth: "5px",
					borderLeftStyle: "solid",
					borderRightStyle: "solid",
					borderLeftColor: "white",
					borderRightColor: "white",
					"&:hover": {
						borderLeftColor: "notes.hoverBg",
						borderRightColor: "notes.hoverBg",
						backgroundColor: "notes.hoverBg"
					}
				}}
			>
				<Typography
					variant={"body1"}
					sx={{
						padding: "5px 10px",
						marginBottom: 0,
						wordBreak: "break-word"
					}}
					paragraph
				>
					{instruction.heading}
				</Typography>
				<span style={{ flexGrow: 1 }} />
			</Card>
		</div>
	)
}
export function HelpVideo({instruction}) {
	return (
		<Card
			variant={"note"}
			sx={{
				display: "flex",
				alignItems: "stretch",
				position: "relative",
				width: "100%",
				backgroundColor: "white",
				borderLeftWidth: "5px",
				borderRightWidth: "5px",
				borderLeftStyle: "solid",
				borderRightStyle: "solid",
				borderLeftColor: "white",
				borderRightColor: "white",
				padding: "5px 10px",
				marginBottom: 0,
				wordBreak: "break-word",
				"&:hover": {
					borderLeftColor: "notes.hoverBg",
					borderRightColor: "notes.hoverBg",
					backgroundColor: "notes.hoverBg"
				}
			}}
		>
			<CardMedia
				component="iframe"
				height={"315"}
				src={`https://www.youtube.com/embed/${instruction.videoId}?rel=0`}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
				title="Embedded youtube"
			/>
			<span style={{ flexGrow: 1 }} />
		</Card>
	)
}